import { MigratableJson } from '../MigratableJson';

export default function toV1<T extends MigratableJson>(data: T): T {
  // Return as-is - the runner will set version: 1
  return data;
}
